const state = {
  phoneNumbers: []
}

const getters = {
  phoneNumbers (state) {
    return state.phoneNumbers
  }
}

const mutations = {
  SET_PHONE_NUMBERS (state, phoneNumbers) {
    state.phoneNumbers = phoneNumbers
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
